import { ProductTypes } from 'products-data';
import { STANDARD_CART_ITEM_RESULT_VIEW_COMPONENTS } from './standard/component-provider/tokens';
import { WIRE_CUT_CART_ITEM_RESULT_VIEW_COMPONENTS } from './wire-cut/component-provider/tokens';

export const CART_ITEM_RESULT_VIEW_COMPONENT_TOKENS = {
  [ProductTypes.Standard]: STANDARD_CART_ITEM_RESULT_VIEW_COMPONENTS,
  [ProductTypes.Wire]: WIRE_CUT_CART_ITEM_RESULT_VIEW_COMPONENTS,
};
